import {cachedValueCreate, ObservableValue, Values} from "@wix/devzai-utils-common";
import {useObservableValue} from "@wix/devzai-utils-react";
import {DomEventListener} from "@wix/devzai-utils-dom";
import {classes} from './doppe-app-layout.st.css';

export const DoppeAppLayout = {
    Narrow: 'narrow',
    Wide: 'wide'
} as const;

export const DoppeAppLayoutNarrowLayoutWidth = 768;

export type DoppeAppLayout = Values<typeof DoppeAppLayout>;

const cachedObservableDoppeAppLayout = cachedValueCreate(() => {
    const observableDoppeAppLayout = new ObservableValue(doppeAppLayoutResolveFromViewportWidth(window.innerWidth))

    DomEventListener.bind(window, 'resize', () => {
        observableDoppeAppLayout.setValue(doppeAppLayoutResolveFromViewportWidth(window.innerWidth));
    })

    return observableDoppeAppLayout;
})

export function doppeAppLayoutGetObservable () {
    return cachedObservableDoppeAppLayout.getValue();
}

export function doppeAppLayoutGetCurrent () {
    return doppeAppLayoutGetObservable().getValue();
}

export function useDoppeAppLayout () {
    return useObservableValue(doppeAppLayoutGetObservable());
}

export function useDecreasedSizeOnNarrowLayout<S> (
    preferredSize: S,
    sortedSizes: S[],
    isEnabled = true
) {
    useObservableValue(isEnabled ? doppeAppLayoutGetObservable() : undefined);

    if (!isEnabled) {
        return preferredSize;
    } else {
        const doppeAppLayout = doppeAppLayoutGetCurrent();

        if (doppeAppLayout === DoppeAppLayout.Wide) {
            return preferredSize;
        } else {
            const preferredSizeIndex = sortedSizes.indexOf(preferredSize);

            if (preferredSizeIndex > 0) {
                return sortedSizes[preferredSizeIndex - 1];
            } else {
                return preferredSize;
            }
        }
    }
}

export function doppeAppLayoutResolveFromViewportWidth (viewportWidth: number) {
    if (viewportWidth < DoppeAppLayoutNarrowLayoutWidth) {
        return DoppeAppLayout.Narrow;
    } else {
        return DoppeAppLayout.Wide;
    }
}

export function doppeAppLayoutGap (gap: 4 | 6 | 8 | 12 | 18 | 24) {
    switch (gap) {
        case 4: return classes.gap4;
        case 6: return classes.gap6;
        case 8: return classes.gap8;
        case 12: return classes.gap12;
        case 18: return classes.gap18;
        case 24: return classes.gap24;
        default: return undefined;
    }
}

export function doppeAppLayoutPageBody () {
    return classes.pageBody;
}

export function doppeAppLayoutPageBodyCentered () {
    return classes.pageBodyCentered;
}

export function doppeAppLayoutFluidPageBody () {
    return classes.pageBodyFluid;
}

export function doppeAppLayoutPageBodySectionsList () {
    return classes.pageBodySectionsList;
}